import Dialog from '@mui/material/Dialog';
import {
  Grid,
  Paper,
  DialogTitle,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Draggable from 'react-draggable';
import DeviceDetails from './DeviceDetails';

export const DeviceDetailsModal = ({
  isOpen, data, merchantId, deviceId, onClose,
}) => {
  const renderContent = () => {
    return (
      <>
        <Grid item textAlign="initial" xs={12}>
          <DeviceDetails
            data={data}
            merchantId={merchantId}
            deviceId={deviceId}
            onClose={onClose}
          />
        </Grid>
      </>
    );
  };

  const PaperComponent = (props) => {
    return (
      <Draggable
        handle="#device-details-modal-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="add-device-modal-title"
        aria-describedby="add-device-modal-description"
        PaperComponent={PaperComponent}
      >
        <DialogTitle
          id="device-details-modal-title"
          style={{ cursor: 'move' }}
          sx={{
            typography: 'h4', color: 'textPrimary',
          }}
        >
          Device Details
        </DialogTitle>
        <DialogContent>
          {renderContent()}
        </DialogContent>
      </Dialog>
    </>
  );
};
